<template>

    <b-modal ref="reAddSite" modal-class="readdsitepopup" centered :lazy="true" title="Are You Sure?" :hide-header-close="true" no-fade>
        <div class="prompt-text">
            Are you sure you want to re-add this website?
        </div>
        <div class="text-center p-4">
            <h5 class="site-name">
                {{site.name}}
            </h5>
            <div class="form-group mx-5">
                <b-form-group label="Activation Key" label-for="url_input">
                    <input id="url_input" ref="urlinput" class="form-control" type="text" v-model="form.activationKey" placeholder="" required />
                </b-form-group>
            </div>
        </div>
        <div slot="modal-footer" class="w-100">
            <div class="float-right">
                <b-btn variant="flat" @click="close">
                    No! Don't
                </b-btn>
                <b-btn variant="danger" @click="reAddSite">
                    Re-add Site
                    <spinner size="small" v-if="buttonLoaders.readd"></spinner>
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
  name: "ReAddSite",
  props: ["site"],
  data() {
    return {
      buttonLoaders: {
        readd: false
      },
      form: {
        activationKey: ""
      }
    };
  },
  created(){
    this.form.activationKey= "";
    this.buttonLoaders.readd=false;
  },
  methods: {
    close() {
      this.form.activationKey= "";
      this.buttonLoaders.readd=false;
      this.$refs.reAddSite.hide();
    },
    reAddSite() {
      this.buttonLoaders.readd = true;
      let payload = {};
      payload.action = "readdSite";
      payload.args = {
        params: {
          activationKey: this.form.activationKey
        },
        siteIDs: [this.site.siteID]
      };

      payload.requiredData = {
        getSitesV3: 1
      };
      this.$store.dispatch("sendAction", payload).then(response => {
        this.buttonLoaders.readd = true;
        this.$store.commit("SET_SITES", response.data.getSitesV3);
        this.close();
      });
    }
  }
};
</script>

<style>

</style>
